import { makeKTBlock, makeSwal } from './functions';
import { BASE_URL } from './variables';

const fetchConsultationData = function (el) {
  const $curEl = $(el);

  $('#modalDetailActivity').modal('show');

  $('#modalDetailActivity [name="editCalendarID"]').val($curEl.attr('data-id'));
  makeKTBlock('#modalDetailActivity form');

  $.post(`${BASE_URL}Activities/getActivityDetails`, {
    type: 'DATABASE',
    id: $curEl.attr('data-id'),
  })
    .done((resp) => {
      if (resp.code != 200) {
        makeKTBlock('#modalDetailActivity form', 'hide');
        makeSwal('Unknown Error has Occured! Please try again!', null, 'error', null, '375px', null, false);
        return;
      }

      /** Insert element dinamis ke body */
      $('#modalDetailActivity .activity-row').remove();
      $('#modalDetailActivity').find('.modal-body').append(resp.page);

      /** Re-init Selectpicker */
      $('#modalDetailActivity .selectpicker').each(function () {
        $(this).selectpicker();
      });

      // Cek dulu ini activity-nya udah beres atau belom
      const curResp = resp.data;
      console.log(curResp)
      
      if (curResp.STATUS == 'COMPLETED') {
        $('#modalDetailActivity [name="curStatus"]').attr('disabled', true).prop('checked', true);
      } else {
        $('#modalDetailActivity [name="curStatus"]').attr('disabled', false).prop('checked', false);
      }

      $('#modalDetailActivity [name="curStatus"]').prop('checked', false);

      if (curResp.STUDENT_ID) {
        if (curResp.STUDENT_NUMBERS != '-' || curResp.STUDENT_NUMBERS != null || curResp.STUDENT_NUMBERS != ' ') {
          const sanitizedNumber = curResp.STUDENT_NUMBERS.replace('+', '').replace('-', '').replace(' ', '').trim();
  
          $('#modalDetailActivity #studentWhatsappContact').show().attr('href', `https://api.whatsapp.com/send?phone=${sanitizedNumber}`);
        } else {
          $('#modalDetailActivity #studentWhatsappContact').hide().attr('href', '');
        }
      }

      $('#modalDetailActivity [name="curFutureFU"]').prop('checked', false).trigger('change');
      $('#modalDetailActivity #futureFUCard').hide();
      $('#modalDetailActivity #futureFUSections').hide();

      $('#modalDetailActivity').find('button[type="submit"]').attr('disabled', true);

      makeKTBlock('#modalDetailActivity form', 'hide');
    })
    .fail((err) => {
      console.log('Error', err);
      KTApp.unblock('#modalDetailActivity');

      Swal.fire({
        html: 'Invalid ID! Please try again',
        icon: 'error',
        confirmButtonText: 'Close',
        showCancelButton: false,
      });
    });
};

export { fetchConsultationData };
